import { memo } from 'react';

import { type ElementInfo } from '~/components/DevModal/types';
import { BoxModelDiagram } from './ElementInspector/BoxModelDiagram';
import { BoxModelOverlays } from './ElementInspector/BoxModelOverlays';
import { GapVisualization } from './ElementInspector/GapVisualization';

type ElementInspectorOverlayProps = {
  elementInfo: ElementInfo;
};

/**
 * Professional element inspector overlay showing box model, gaps, and detailed information.
 */
export const ElementInspectorOverlay = memo(({ elementInfo }: ElementInspectorOverlayProps) => {
  return (
    <>
      <BoxModelOverlays elementInfo={elementInfo} />
      <GapVisualization elementInfo={elementInfo} />
      <BoxModelDiagram elementInfo={elementInfo} />
    </>
  );
});

ElementInspectorOverlay.displayName = 'ElementInspectorOverlay';
